import { render, staticRenderFns } from "./DropdownOptionItem.vue?vue&type=template&id=15702ef8&scoped=true"
import script from "./DropdownOptionItem.vue?vue&type=script&lang=ts"
export * from "./DropdownOptionItem.vue?vue&type=script&lang=ts"
import style0 from "./DropdownOptionItem.vue?vue&type=style&index=0&id=15702ef8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15702ef8",
  null
  
)

export default component.exports